import { SearchBaseIconRaw } from '@tableau/icons/SearchBaseIcon/raw';
import { Colors } from '@tableau/icons/util/Colors';
import { style } from "typestyle";
import { CommonStyles } from "./commonInfra/styles/CommonStyles";
import { SearchBoxIconSize } from './omnibox/common/Constants';


const IconColors = {
    Rest: Colors.Default,
    Focus: '#2e2e2e',
    Hover: '#2e2e2e',
    Disabled: '#c9c9c9',
}

const searchIcon = {svg: (color:string) => encodeSvgUrl(SearchBaseIconRaw(SearchBoxIconSize, color))}

function encodeSvgUrl(svg: string): string {
    return `url('data:image/svg+xml,${encodeURIComponent(svg)}')`;
}

export const overallStyles = style({
    $nest: {
        '.tb-omnibox': {
            display: 'inline-block',
            verticalAlign: 'top',
            position: 'relative',
            textAlign: 'left',
            //width: '100%',
            maxWidth: 'initial',
            height: '32px',

            $nest: {
                '&.for-serp': {
                    width: 560,
                    $nest: {
                        '.tb-omnibox-search-box': {
                            position: 'relative',
                            display: 'block',
                            $nest: {
                                '.search': {
                                    display: 'block',
                                    width: '100%',
                                    $nest: {
                                        'input': {
                                            width: '100%',
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                '.tb-omnibox-text-box': {
                    $nest: {
                        '.tb-omnibox-search-box': {
                            display: 'flex',
                            backgroundColor: '#fff',

                            $nest: {
                                'input': {
                                    width: '370px',
                                    height: '32px',
                                    fontSize: '14px',
                                    transition: 'width 0.25s ease-in-out',
                                    paddingLeft: '36px',
                                    backgroundPosition: '9px',
                                    backgroundImage: searchIcon.svg(IconColors.Rest),
                                    $nest: {
                                        '&:hover:enabled:not(:focus)': { backgroundImage: searchIcon.svg(IconColors.Hover), },
                                        '&:focus': { backgroundImage: searchIcon.svg(IconColors.Focus), },
                                        '&:disabled': { backgroundImage: searchIcon.svg(IconColors.Disabled), },
                                        '&:placeholder-shown': {
                                            textOverflow: 'ellipsis',
                                        }
                                    }
                                }
                            }
                        },
                        '.tb-omnibox-search-box-long': {
                            $nest: {
                                'input': {
                                    width: '562px'
                                }
                            }
                        },
                        '.tb-omnibox-press-enter-to-see-all': {
                            paddingTop: '7px',
                            position: 'absolute',
                            right: '14px',
                            pointerEvents: 'none',
                            fontSize: '14px',

                        }
                    }
                }
            }
        }
    }
});

export const popupOverallStyles = style({
    backgroundColor: '#fff',
    backgroundClip: 'padding-box',
    boxShadow: '0 7px 15px rgb(0 0 0 / 20%)',
    width: '560px',

    $nest: {
        'a': {
            textDecoration: 'none',
            cursor: 'pointer',
            outline: '0',
            color: CommonStyles.Colors.Grey102,
            fontSize: CommonStyles.Sizes.NormalFontSize

        },
        '.tb-quicklinks-section-divider': {
            borderTop: '1px solid #e6e6e6',
        },
        '.tb-quicklinks-row': {
            display: 'table',
            margin: '4px 0 0 0',
            width: '100%',
            alignItems: 'stretch',

        },
        '.tb-quicklinks-highlight': {
            textAlign: 'center',
            display: 'inline-block',
            width: '75px',
            padding: '14px 15px 10px 15px',
            margin: '0',
            color: '#666',
            verticalAlign: 'top',
            height: '100%',
            $nest: {
                '&:hover,&:focus': {
                    backgroundColor: CommonStyles.Colors.Grey245,
                    color: CommonStyles.Colors.Grey102,
                    textDecoration: 'none',
                },
                '&.activeSectionItem': {
                    backgroundColor: CommonStyles.Colors.BlueHighlight
                }
            }
        },
        '.tb-quicklinks-highlight-border': {
            border: '1px solid #bfbfbf',
            borderRadius: '50%',
            margin: 'auto',
            height: '40px',
            width: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    }
});